import { Backspace, X } from "@phosphor-icons/react";
import { createPortal } from "react-dom";
import { Button } from "@/components/ui/button";

const KEYS = [
    ["7", "8", "9"],
    ["4", "5", "6"],
    ["1", "2", "3"],
    ["0", ",", "←"],
];

export default function Numpad({ targetLabel, value, onPress, onClear, onApply, onClose }) {
    if (typeof document === "undefined") return null;
    return createPortal(
        <div
            data-testid="numpad-panel"
            className="fixed bottom-6 right-6 w-[460px] max-w-[calc(100vw-3rem)] bg-white border-2 border-[#5856D6] shadow-2xl flex flex-col"
            style={{ zIndex: 9999, pointerEvents: "auto" }}
        >
            <div className="flex items-center justify-between px-4 py-3 bg-[#5856D6] text-white">
                <div className="min-w-0">
                    <div className="text-[10px] font-bold uppercase tracking-[0.25em] opacity-90">
                        ΑΡΙΘΜΗΤΙΚΟ ΠΛΗΚΤΡΟΛΟΓΙΟ
                    </div>
                    <div className="text-sm font-bold truncate">
                        {targetLabel}
                    </div>
                </div>
                <button
                    onClick={onClose}
                    data-testid="numpad-close-btn"
                    className="p-1.5 hover:bg-white/20 active:scale-95 transition-all shrink-0"
                >
                    <X size={22} weight="bold" />
                </button>
            </div>

            <div className="p-4 flex flex-col gap-3">
                {/* Display */}
                <div
                    data-testid="numpad-display"
                    className="bg-[#FAFAFA] border-2 border-[#0A0A0A] px-4 py-3 text-right font-mono text-4xl font-black min-h-[64px] truncate flex items-center justify-end"
                >
                    {value || "\u00A0"}
                </div>

                {/* Keys */}
                <div className="grid grid-cols-3 gap-2">
                    {KEYS.flat().map((k) => (
                        <button
                            key={k}
                            onClick={() => onPress(k)}
                            data-testid={`numpad-key-${k}`}
                            className="bg-white border-2 border-[#0A0A0A] hover:bg-[#0A0A0A] hover:text-white active:scale-95 transition-all font-heading text-4xl font-black tracking-tighter flex items-center justify-center h-20 select-none"
                        >
                            {k === "←" ? <Backspace size={28} weight="bold" /> : k}
                        </button>
                    ))}
                </div>

                {/* Actions */}
                <div className="grid grid-cols-2 gap-2">
                    <Button
                        onClick={onClear}
                        data-testid="numpad-clear-btn"
                        className="rounded-none h-14 bg-white border-2 border-[#FF3B30] text-[#FF3B30] hover:bg-[#FF3B30] hover:text-white font-black text-sm tracking-wider"
                    >
                        ΚΑΘΑΡΙΣΜΟΣ
                    </Button>
                    <Button
                        onClick={onApply}
                        data-testid="numpad-apply-btn"
                        className="rounded-none h-14 bg-[#002FA7] hover:bg-[#001D66] text-white font-black text-sm tracking-wider"
                    >
                        ΕΦΑΡΜΟΓΗ
                    </Button>
                </div>
            </div>
        </div>,
        document.body
    );
}
